import { useEffect, useState } from 'react';

export const useBlogList = ({ limit = 20, after = null, tag = null, q = null } = {}) => {
  const [data, setData] = useState({ items: [], next_cursor: null, has_more: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (after) params.set('after', after);
    if (tag) params.set('tag', tag);
    if (q) params.set('q', q);

    fetch(`/api/blogs?${params.toString()}`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch');
        return res.json();
      })
      .then((d) => {
        if (!cancelled) {
          setData({
            items: d.items || [],
            next_cursor: d.next_cursor || null,
            has_more: !!d.has_more,
          });
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setData({ items: [], next_cursor: null, has_more: false });
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [limit, after, tag, q]);

  return { ...data, loading };
};

export const usePublishedBlogTags = () => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/blog-tags')
      .then((res) => (res.ok ? res.json() : []))
      .then((t) => {
        if (!cancelled) setTags(Array.isArray(t) ? t : []);
      })
      .catch(() => {
        if (!cancelled) setTags([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return tags;
};

// Convenience for small fixed lists (featured etc). Returns array (or []).
export const usePublishedBlogs = (limit = 4) => {
  const { items, loading } = useBlogList({ limit });
  if (loading) return null;
  return items;
};

export const useBlogBySlug = (slug) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetch(`/api/blogs/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error('not_found');
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setPost(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPost('not_found');
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { post, loading };
};
